/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DocIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DocIcon({
  children,
  viewPath = "/DesignSystem/Svgs/DocIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 32,
  height = 32,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "none",
  stroke = "#474747"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="DocIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 32 32"
 overflow="visible"
 style={{'--as-1-ZVXvjx': alignSelf,'--mt-2-ZVXvjx': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZVXvjx': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZVXvjx': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZVXvjx': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZVXvjx': opacity,'--w-10-ZVXvjx': typeof width === 'number' ? `${width}px` : width,'--h-11-ZVXvjx': typeof height === 'number' ? `${height}px` : height,'--a-7-ZVXvjx': isAnimated ? animation : "none",'--sd-8-ZVXvjx': isAnimated ? strokeDashoffset : 0,'--sd-9-ZVXvjx': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="DocIcon.SvgPath"
  data-view-path={viewPath}
 strokeWidth={4}
 strokeLinejoin="bevel"
 strokeMiterlimit={10}
 d="M16 11.9h9.4L16 2.5z"
 style={{'--f-12-ZVXvjx': fill,'--s-13-ZVXvjx': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="DocIcon.SvgPath:1"
  data-view-path={viewPath}
 strokeWidth={4}
 strokeMiterlimit={10}
 d="M16 2.5H6.6v27h18.8V11.9z"
 style={{'--f-12-ZVXvjx': fill,'--s-13-ZVXvjx': stroke}}
 className={`views-block ${styles.SvgPath1}`}
/>
</svg>
{children}
</React.Fragment>)
}